import React from "react";
import { withRouter } from "react-router-dom";
import Presenter from "./Presenter";

import { useQuery } from "react-apollo-hooks";
import { STORE_DELIVERY_PLACE_LIST_QUERY } from "../Queries";

import qs from "qs";

export default withRouter(({ history, match, location }) => {
  const queryString = qs.parse(location.search.substr(1));

  const dayOfWeek = queryString.dayOfWeek ? queryString.dayOfWeek : "";
  const keyword = queryString.keyword ? queryString.keyword : "";
  const page = queryString.page ? +queryString.page : 1;
  const take = 15;
  const baseUrl = "/delivery/deliveryPlaces";

  const { data, loading, error } = useQuery(STORE_DELIVERY_PLACE_LIST_QUERY, {
    fetchPolicy: "network-only",
    variables: {
      dayOfWeek,
      take,
      skip: (page - 1) * take,
      keyword,
    },
  });

  // if (loading) {
  //   return <></>;
  // }
  if (error) {
    var message = error.toString();
    message = message.replace("Error: GraphQL error:", "");
    return <>{message}</>;
  }

  return (
    <Presenter
      history={history}
      match={match}
      location={location}
      dayOfWeek={dayOfWeek}
      keyword={keyword}
      page={page}
      take={take}
      loading={loading}
      data={data}
      baseUrl={baseUrl}
    />
  );
});
